export default {"src":"/_next/static/media/playerPagePlaceholder.b29be5b0.svg","height":68,"width":68};